<template>
  <div class="banner cardBackground">
    <!-- Everything you place between <Banner>…</Banner> will appear here -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BannerComponent',
}
</script>

<style scoped>

.banner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem;
  position: relative;
  left: 50%;
  width: 100vw;
  transform: translateX(-50%);
  border: none;
}

</style>
